import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router, } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { SecureCheckDialogComponent, WarningdialogComponent, AnnounceDialogComponent, } from "../../modalDialogs";
import { Observable } from "rxjs";
import { SnackBarMessageType } from "../../shared/contentTypes";
import { snackBarMessageKey, SnackBarService, } from "../../services/snackBar.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { AnounceModalResult } from "../../shared/contentTypes";
import { RemoteOrderGroupShareService } from "./remoteOrderGroupShare.service";
import { GroupStateService } from "../../services/groupState.service";
import { CoreLanguageService } from "../../services/language.service";

@Component({
  selector: "remoteOrderGroupShare",
  templateUrl: "./remoteOrderGroupShare.component.html",
  styleUrls: ["./remoteOrderGroupShare.component.scss"],
  providers: [RemoteOrderGroupShareService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoteOrderGroupShareComponent implements OnInit, OnDestroy {
  private _langSubscriber: Subscription;
  public isSmallView: boolean = false;
  public shownavigatetomenu: boolean;
  public hasShared: boolean = false;
  public groupIsFull$: Observable<boolean>;

  constructor(
    private _location: Location,
    private _remoteOrdergroupShareService: RemoteOrderGroupShareService,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _mainnavService: MainnavService,
    private internationalisationService: InternationalisationService,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _snackBarService: SnackBarService,
    private _iosHelperService: IOSHelperService,
    private _groupStateService: GroupStateService,
    private _coreLanguageService: CoreLanguageService
  ) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RemoteOrderGroupShareComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.groupIsFull$ = me._remoteOrdergroupShareService.groupIsFull$;
    me.shownavigatetomenu = me._groupStateService.getshownavigatetomenu();
    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(
      () => {
        me.PushChanges();
      }
    );
  }

  /** Share link*/
  //!MARK: No browser compatibility: Firefox and Webview Android
  public ShareLink() {
    const me = this;
    try {
      (navigator as any).share({
        url: me._remoteOrdergroupShareService.groupLink,
      });
    } catch (err) {
      me.OpenCopyLinkDialog();
    }
    me.hasShared = true;
  }

  /**Confirm and navigate to menu group*/
  public confirmAndNavigate() {
    const me = this;
    if (!me.hasShared) {
      me._openAnnounceDialog();
    } else {
      me._router.navigate(['/menugroup']);
    }

  }

  /**Detrmines the button text based on the shared status*/
  public OrderButtonLabel() {
    const me = this;
    const orderNow = "phRemoteOrder_Invite_OrderBtn";
    const orderWithoutInvite = "phRemoteOrder_Without_Invite_Btn";
    const buttonLabel = me.hasShared ? orderNow : orderWithoutInvite;
    return me._coreLanguageService.value(buttonLabel)
  }

  /**Dialog: invite friends or put order*/
  private _openAnnounceDialog() {
    const me = this;
    const warningDialog = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "phRemoteOrder_Confirm_Invite_Dialog_Title"
        , content: "phRemoteOrder_Confirm_Invite_Dialog_SubText"
        , firstBtnLabel: "phRemoteOrder_Confirm_Invite_Dialog_OrderBtn"
        , secondBtnLabel: "phRemoteOrder_Confirm_Invite_Dialog_InviteBtn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningDialog.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
        me._router.navigate(["/menugroup"]);
      } else {
        // nothing
      }
    });
  }

  /**Dialog: group is full*/
  public OpenWarningGroupIsFull() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(
      WarningdialogComponent,
      {
        data: {
          title: "phRemoteOrder_MaxMemberCount_Dialog_Title",
          content: "phRemoteOrder_MaxMemberCount_Dialog_SubText",
          btnLabel: "phGlobal_Continue",
        },
        panelClass: "mat-bottom-sheet-container-medium",
      }
    );
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/TODO: groupserviceselector"]);
      }
    });
  }

  /** open copy link dialog if share not available */
  private OpenCopyLinkDialog() {
    const me = this;
    const copyLinkDialog = me._bottomSheetHelperService.open(
      SecureCheckDialogComponent,
      {
        data: {
          title: "phGroupOrder_Share_Link_NotAvailable_Title",
          description: "phGroupOrder_Share_Link_NotAvailable_Subtext",
          buttonTextAccept: "phGroupOrder_Share_Link_Copy_Btn",
          buttonTextDeny: "phGlobal_Continue",
          icon: "hypersoft-achtung.svg",
        },
        panelClass: "mat-bottom-sheet-container-medium",
      }
    );
    copyLinkDialog.afterDismissed().subscribe((result) => {
      if (result) {
        if (window.isSecureContext) {
          // copy to clipboard only with secure origin https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
          window.navigator["clipboard"]
            .writeText(me._remoteOrdergroupShareService.groupLink)
            .then(() => {
              me._snackBarService.ShowMessage(
                snackBarMessageKey.copiedToClipboard,
                SnackBarMessageType.Successful
              );
            })
            .catch(() => {
              me._snackBarService.ShowErrorMessageFailed(130);
            });
        } else {
          me.copy(me._remoteOrdergroupShareService.groupLink);
          me._snackBarService.ShowMessage(
            snackBarMessageKey.copiedToClipboard,
            SnackBarMessageType.Successful
          );
        }
        me.setWebView();
      } else {
        // nothing
      }
    });
  }

  //workaround https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript/33928558#33928558
  private copy(text) {
    var input = document.createElement("textarea");
    input.innerHTML = text;
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand("copy");
    document.body.removeChild(input);
    return result;
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** navigate back */
  public navigateBack(): void {
    this._location.back();
  }
}
